import { defineMessages } from 'react-intl';

const trns = defineMessages({
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  tips: {
    id: 'Bg+SsQ',
    defaultMessage: 'Блог'
  },
  moreHelpfulTips: {
    id: 'qMWo+V',
    defaultMessage: 'Більше корисних порад'
  },
  myFirstAidKitTips: {
    id: 'oSib7G',
    defaultMessage: 'Моя аптечка'
  },
  myFirstAidKitTipsDescription1: {
    id: 'j27bc2',
    defaultMessage:
      "У кожному будинку є місце, де зберігаються ліки. Але при цьому аптечка часто формується випадковим чином і перетворюється на склад непотрібних препаратів, що залишилися після хвороб членів сім'ї. У той же час, дійсно потрібні ліки для надання першої допомоги в ній відсутні."
  },
  aboutCovid: {
    id: 'PSI4OV',
    defaultMessage: 'Alarm, COVID'
  },
  aboutCovidDescription1: {
    id: '+UnCnR',
    defaultMessage:
      "Вже майже два роки в Україні продовжується епідемія COVID-19. Вірус постійно мутує, з'являються нові симптоми та алгоритми лікування. Ми зібрали актуальні рекомендації, як не розгубитися за перших ознак хвороби і що робити, якщо контактував із зараженим."
  },
  help: {
    id: 'OUNj6I',
    defaultMessage: 'Допомога'
  },
  helpDescription1: {
    id: 'RVVfaM',
    defaultMessage:
      'Аварії, катастрофи, стихійні лиха, на жаль, трапляються у нашому житті. І від того, як швидко буде надано допомогу, часто залежить життя людей. Згідно зі статистикою, в подіях, де є постраждалі, протягом години гине близько 30% людей, які могли б вижити, якби їм надали правильну першу допомогу.'
  },
  aboutSkin: {
    id: '7J2r4x',
    defaultMessage: 'Шкіра як індикатор захворювань'
  },
  readMore: {
    id: '3P89Sg',
    defaultMessage: 'читати далі'
  },
  aboutSkinDescription1: {
    id: 'JWxMXi',
    defaultMessage:
      "Шкіра є важливим індикатором здоров'я. По обличчю людини можна легко визначити внутрішній стан її організму🙌🏼 Крім того, зовнішній вигляд шкіри безпосередньо залежить від якості догляду за нею."
  },
  blogPageTitle: {
    id: 'y/Bi5t',
    defaultMessage: 'Блог корисних статей'
  },
  aboutUs: {
    id: 'RAlXQq',
    defaultMessage: 'Про компанiю'
  }
});

export default trns;
